// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--350MN","carousel":"gallery-module--carousel--JqMCh","slide":"gallery-module--slide--1iPS_"};